import solidBullet from '../../../../assets/dashboard-svg/solid-bullet.svg';
import solidBulletGray from '../../../../assets/dashboard-svg/solid-bullet-gray.svg';

import { colors } from '../../../../../src/theme/color-palette.js';
import { LEGENDS, NETSALES, UNITS } from '../../../../constants/constant';
import { convertToInternationalCurrencySystem } from '../../../../helper/convertAmount.js';

export const getChannelName = (legend, isSmallScreen) => {
	if (isSmallScreen) {
		if (legend === 'DELIVERY') {
			return 'DLV';
		}
		if (legend === 'PICKUP') {
			return 'PU';
		}
		return legend;
	}
	return LEGENDS[legend];
};

export const isEmptyObject = (obj) => {
	return Object.keys(obj).length === 0;
};

export const getHeaders = (tabValue) => {
	const TAB_NAMES = [NETSALES, UNITS];
	const absYoYName = ['$ Chg', 'Qty Chg'];
	const prefix = tabValue === 0 ? '$' : '';
	const getSign = (value) => (value < 0 ? '-' : '');

	return [
		{
			value: 'labelName',
			label: '',
			align: 'right',
			valueRenderer: (name) => name,
			excelLabel: 'Channel Name',
			showOnDashboard: true,
		},
		{
			value: 'tyValue',
			label: TAB_NAMES[tabValue],
			align: 'right',
			valueRenderer: (value) =>
				prefix + convertToInternationalCurrencySystem(value),
			excelLabel: `This year ${String(TAB_NAMES[tabValue])?.toLowerCase()}
						${TAB_NAMES[tabValue] === 'Units' ? '' : ' ($)'}`,
			showOnDashboard: true,
		},
		{
			value: 'lyValue',
			label: TAB_NAMES[tabValue],
			align: 'right',
			valueRenderer: (value) =>
				prefix + convertToInternationalCurrencySystem(value),
			excelLabel: `Last year ${String(TAB_NAMES[tabValue])?.toLowerCase()}
						${TAB_NAMES[tabValue] === 'Units' ? '' : ' ($)'}`,
			showOnDashboard: false,
		},
		{
			value: 'absYoY',
			label: absYoYName[tabValue],
			align: 'right',
			valueRenderer: (value) =>
				value == -999999
					? 'NA'
					: getSign(value) +
					  prefix +
					  convertToInternationalCurrencySystem(value),
			excelLabel: absYoYName[tabValue],
			showOnDashboard: true,
		},
		{
			value: 'yoy',
			label: '% Chg',
			align: 'right',
			valueRenderer: (value) =>
				value === -999999 ? 'NA' : Math.abs(value.toFixed(1)) + '%',
			excelLabel: '% Chg',
			showOnDashboard: true,
		},
	];
};

export const tooltip = (field) => {
	const fieldName = {
		tyValue: 'This Year',
		lyValue: 'Last Year',
	};
	const bullet = field === 'tyValue' ? solidBullet : solidBulletGray;
	const value = field === 'tyValue' ? 'tyValueTooltip' : 'lyValueTooltip';
	return `<div style="font-size: 12px; width: 142px; text-align: left; color: ${colors.FONT_COLOR} padding: 12px 16px" >
    <div style="width: 100%;">
        <div style="display: inline-block; width: 50%; line-height: 16px; color: ${colors.FONT_COLOR}""> 
            <img style="margin: 0 4px 0 0;" src=${bullet} /> ${fieldName[field]}
        </div>
        <div style="font-size: 12px; display: inline-block; width: 45%; line-height: 16px; font-weight: 700; text-align: right; color: ${colors.FONT_COLOR}">{${value}}</div>
    </div>
    </div>`;
};
